module.exports = __webpack_public_path__ + "static/img/fundingimage.dc1be30.svg";